import { render, staticRenderFns } from "./AtomSpinner.vue?vue&type=template&id=fb9a33c4&scoped=true&"
import script from "./AtomSpinner.vue?vue&type=script&lang=js&"
export * from "./AtomSpinner.vue?vue&type=script&lang=js&"
import style0 from "./AtomSpinner.vue?vue&type=style&index=0&id=fb9a33c4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb9a33c4",
  null
  
)

export default component.exports